var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated"},[_c('system-activity',{attrs:{"uri":"","showUTCtime":_vm.showUTCtime}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }